import apiClient from "../../../utils/apiClient";

export const getAllVaccines = () => {
  return apiClient.get("/public/vaccines");
};
